<div class="ts1-rating-maneuver-sidebar">
	@for (label of maneuvers; track $index; let i = $index) {
		<div
			class="ts1-rating-maneuver-item"
			[class.ts1-rating-maneuver-item--active]="activeIndex === i"
			[class.ts1-rating-maneuver-item--none]="activeIndex !== i && statusForIndex(i) === 'none'"
			[class.ts1-rating-maneuver-item--na]="activeIndex !== i && statusForIndex(i) === 'na'"
			[class.ts1-rating-maneuver-item--rated]="activeIndex !== i && statusForIndex(i) === 'rated'"
			(click)="select(i)"
		>
			<span class="ts1-rating-maneuver-item__label truncate" [matTooltip]="label">{{ label }}</span>
		</div>
	}
</div>
